package com.vamvisions.main.portfolio.domain.model

/** The page section of an [Experience]. The declaration order is the order the server lists them in. */
enum class ExperienceSection { TIMELINE, LEARNING, EDUCATION }

/**
 * An experience entry of [section]. [highlights] are lines, possibly none: one line is a paragraph, several are
 * bullet points. [end] is null while it is ongoing. [url] is absolute, a site-relative path starting with `/`, or null
 * when the entry links nowhere. [skills] are its featured skills, in order.
 */
data class Experience(
    val slug: String,
    val section: ExperienceSection,
    val name: String,
    val role: String,
    val highlights: List<String>,
    val start: PartialDate,
    val end: PartialDate?,
    val url: String?,
    val skills: List<Skill>,
)
